<template>
  <div class="new-oa-workflow-detail-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>{{ $t('newOaWorkflowDetail.title') }}</span>
            <div class="float-right">
              <el-button type="primary" size="small" @click="_goBack">
                {{ $t('newOaWorkflowDetail.back') }}
              </el-button>
              <el-button type="danger" size="small" v-if="this.status == 1003&&newOaWorkflowDetailInfo.action == 'edit'" @click="_openEditPurchaseModel">
                <i class="el-icon-edit"></i>
                {{ $t('purchaseApplyDetail.edit') }}
              </el-button>
            </div>
          </div>

          <div v-if="newOaWorkflowDetailInfo.pools">
            <el-form>
              <el-row :gutter="20">
                <el-col :span="8">
                  <div class="kv-item">
                    <span class="kv-label">{{ $t('newOaWorkflowDetail.applicant') }}：</span>
                    <span class="kv-value">{{ newOaWorkflowDetailInfo.pools.create_user_name }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="kv-item">
                    <span class="kv-label">{{ $t('newOaWorkflowDetail.applyTime') }}：</span>
                    <span class="kv-value">{{ newOaWorkflowDetailInfo.pools.create_time }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="kv-item">
                    <span class="kv-label">{{ $t('newOaWorkflowDetail.status') }}：</span>
                    <span class="kv-value">{{ _getNewOaWorkflowDetailState(newOaWorkflowDetailInfo.pools) }}</span>
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <template v-for="(item, index) in newOaWorkflowDetailInfo.formJson">
                  <el-col v-if="item.type != 'text' && item.type != 'button'" :key="index" :span="8">
                    <div class="kv-item">
                      <span class="kv-label">{{ item.label }}：</span>
                      <span class="kv-value">{{ getDisplayValue(item, newOaWorkflowDetailInfo.pools[item.key]) }}</span>
                    </div>
                  </el-col>
                </template>
              </el-row>

              <el-row :gutter="20" v-for="(item, index) in newOaWorkflowDetailInfo.files" :key="index">
                <el-col  :span="8">
                  <div class="kv-item">
                    <el-link :href="item.realFileName" target="_blank">{{ item.fileName }}</el-link>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="mt-20">
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>{{ $t('newOaWorkflowDetail.workflowProcess') }}</span>
          </div>

          <el-table :data="newOaWorkflowDetailInfo.comments" border style="width: 100%">
            <el-table-column prop="index" :label="$t('newOaWorkflowDetail.serialNumber')" width="80" align="center">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="orgName" :label="$t('newOaWorkflowDetail.department')" align="center">
              <template slot-scope="scope">
                {{ scope.row.orgName || $t('newOaWorkflowDetail.admin') }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('newOaWorkflowDetail.handler')" align="center">
              <template slot-scope="scope">
                {{ scope.row.staffName }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('newOaWorkflowDetail.status')" align="center">
              <template slot-scope="scope">
                {{ scope.row.endTime ? $t('newOaWorkflowDetail.processed') : $t('newOaWorkflowDetail.processing') }}
              </template>
            </el-table-column>
            <el-table-column prop="endTime" :label="$t('newOaWorkflowDetail.endTime')" align="center" />
            <el-table-column prop="duration" :label="$t('newOaWorkflowDetail.timeConsuming')" align="center" />
            <el-table-column prop="context" :label="$t('newOaWorkflowDetail.comment')" align="center" />
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-row v-if="newOaWorkflowDetailInfo.action == 'audit'" :gutter="20" class="mt-20">
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>{{ $t('newOaWorkflowDetail.workflowHandle') }}</span>
          </div>

          <el-form label-width="120px" class="text-left">
            <el-form-item :label="$t('newOaWorkflowDetail.action')">
              <el-select v-model="newOaWorkflowDetailInfo.audit.auditCode" style="width:100%"
                :placeholder="$t('newOaWorkflowDetail.selectAction')">
                <el-option v-if="newOaWorkflowDetailInfo.nextAudit.next" value="1100"
                  :label="$t('newOaWorkflowDetail.handle')" />
                <el-option v-if="newOaWorkflowDetailInfo.nextAudit.back" value="1200"
                  :label="$t('newOaWorkflowDetail.return')" />
                <el-option v-if="newOaWorkflowDetailInfo.nextAudit.backIndex" value="1400"
                  :label="$t('newOaWorkflowDetail.returnToSubmitter')" />
                <el-option v-if="newOaWorkflowDetailInfo.nextAudit.exit" value="1500"
                  :label="$t('newOaWorkflowDetail.end')" />
<!--                <el-option value="1300" :label="$t('newOaWorkflowDetail.transfer')" />-->
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('newOaWorkflowDetail.workflowDescription')" class="margin-top">
              <el-input type="textarea" :rows="3" :placeholder="$t('newOaWorkflowDetail.descriptionRequired')"
                v-model="newOaWorkflowDetailInfo.audit.auditMessage" />
            </el-form-item>

            <!-- 办理时 判断是否指定 委托人 如果指定了 则不显示 -->
            <el-form-item
              v-if="newOaWorkflowDetailInfo.audit.auditCode == '1100' && newOaWorkflowDetailInfo.nextAudit.assignee == '-2'"
              :label="$t('newOaWorkflowDetail.nextHandler')" class="margin-top">
              <el-input v-model="newOaWorkflowDetailInfo.audit.staffName"
                :placeholder="$t('newOaWorkflowDetail.selectNextHandler')" disabled style="width:80%" />
              <el-button type="primary" @click="chooseStaff" style="margin-left:10px">
                {{ $t('newOaWorkflowDetail.select') }}
              </el-button>
            </el-form-item>

            <!-- 转单时 必须指定 委托人 -->
<!--            <el-form-item v-if="newOaWorkflowDetailInfo.audit.auditCode == '1300'"-->
<!--              :label="$t('newOaWorkflowDetail.nextHandler')" class="margin-top">-->
<!--              <el-input v-model="newOaWorkflowDetailInfo.audit.staffName"-->
<!--                :placeholder="$t('newOaWorkflowDetail.selectNextHandler')" disabled style="width:80%" />-->
<!--              <el-button type="primary" @click="chooseStaff" style="margin-left:10px">-->
<!--                {{ $t('newOaWorkflowDetail.select') }}-->
<!--              </el-button>-->
<!--            </el-form-item>-->

            <el-form-item>
              <el-button type="primary" class="float-right" @click="_auditSubmit">
                {{ $t('newOaWorkflowDetail.submit') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="mt-20">
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>{{ $t('newOaWorkflowDetail.flowChart') }}</span>
          </div>
          <div class="text-center">
            <el-image :src="newOaWorkflowDetailInfo.imgData" style="height:300px" fit="contain" />
          </div>
        </el-card>
      </el-col>
    </el-row>

    <select-staff ref="selectStaff" @selectStaff="handleSelectStaff"/>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { queryOaWorkflowForm, queryOaWorkflowFormData, queryOaWorkflowUser, 
  getNextTask, auditOaWorkflow, listRunWorkflowImage } from '@/api/oa/newOaWorkflowDetailApi'
import SelectStaff from '@/components/staff/SelectStaff'

export default {
  name: 'NewOaWorkflowDetailList',
  components: {
    SelectStaff
  },
  data() {
    return {
      newOaWorkflowDetailInfo: {
        id: '',
        flowId: '',
        pools: {},
        formJson: [],
        comments: [],
        action: '',
        audit: {
          auditCode: '',
          auditMessage: '',
          staffId: '',
          staffName: '',
          taskId: ''
        },
        imgData: '',
        nextAudit: {},
        files: []
      },
      status:'',
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    const id = this.$route.query.id
    if (!id) {
      this.$message.error(this.$t('newOaWorkflowDetail.illegalOperation'))
      return
    }
    this.newOaWorkflowDetailInfo.id = id
    this.newOaWorkflowDetailInfo.flowId = this.$route.query.flowId
    this.newOaWorkflowDetailInfo.action = this.$route.query.action
    this.newOaWorkflowDetailInfo.audit.taskId = this.$route.query.taskId
    this._listOaWorkflowDetails()
    this._loadComments()
    if (this.newOaWorkflowDetailInfo.action) {
      this._loadNextAuditPerson()
    }
    this._openNewOaWorkflowDetailImg()
  },
  methods: {
    async _listOaWorkFlowDetailForm() {
      try {
        const params = {
          page: 1,
          row: 1,
          flowId: this.newOaWorkflowDetailInfo.flowId
        }
        const response = await queryOaWorkflowForm(params)
        this.newOaWorkflowDetailInfo.formJson = JSON.parse(response.data[0].formJson).components
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    async _listOaWorkflowDetails() {
      try {
        const params = {
          page: 1,
          row: 1,
          id: this.newOaWorkflowDetailInfo.id,
          flowId: this.newOaWorkflowDetailInfo.flowId
        }
        const response = await queryOaWorkflowFormData(params)
        this.newOaWorkflowDetailInfo.pools = response.data[0]
        this.newOaWorkflowDetailInfo.files = response.data[0].files
        this._listOaWorkFlowDetailForm()
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    async _loadComments() {
      try {
        const params = {
          communityId: this.communityId,
          id: this.newOaWorkflowDetailInfo.id,
          flowId: this.newOaWorkflowDetailInfo.flowId,
          page: 1,
          row: 10
        }
        const response = await queryOaWorkflowUser(params)
        if (response.code !== 0) return
        this.newOaWorkflowDetailInfo.comments = response.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _openEditPurchaseModel() {
      const query = {
        id: this.newOaWorkflowDetailInfo.id,
        flowId: this.newOaWorkflowDetailInfo.flowId,
        taskId: this.newOaWorkflowDetailInfo.audit.taskId
      }
      // 传递SSO标记，确保编辑页提交后能关闭页签
      if (sessionStorage.getItem('ssoLoginFlag') === 'true') {
        query.ssoLoginFlag = 'true'
      }
      this.$router.push({
        path: '/views/oa/newOaWorkflowFormEdit',
        query
      })
    },
    _goBack() {
      // SSO模式下：能关则关，否则路由回退
      if (this.$route.query.ssoLoginFlag === 'true' || sessionStorage.getItem('ssoLoginFlag') === 'true') {
        sessionStorage.removeItem('ssoLoginFlag')
        if (window.opener) {
          setTimeout(() => {
            window.close()
          }, 500)
        } else {
          this.$router.go(-1)
        }
      } else {
        const flowId = this.newOaWorkflowDetailInfo.flowId
        if (flowId) {
          this.$router.push({
            path: '/views/oa/newOaWorkflow',
            query: { flowId, switchValue: 'newOaWorkflowUndo' }
          })
        } else {
          this.$router.go(-1)
        }
      }

    },
    chooseStaff() {
      this.$refs.selectStaff.open(this.newOaWorkflowDetailInfo.audit)
    },
    handleSelectStaff(staff) {
      this.newOaWorkflowDetailInfo.audit.staffId = staff.userId
      this.newOaWorkflowDetailInfo.audit.staffName = staff.userName
    },
    async _auditSubmit() {
      const audit = this.newOaWorkflowDetailInfo.audit
      audit.flowId = this.newOaWorkflowDetailInfo.flowId
      audit.id = this.newOaWorkflowDetailInfo.id

      if (this.newOaWorkflowDetailInfo.nextAudit.assignee != '-2') {
        audit.staffId = this.newOaWorkflowDetailInfo.nextAudit.assignee;
      }

      if (!audit.auditCode) {
        this.$message.error(this.$t('newOaWorkflowDetail.selectStatus'))
        return
      }
      if (!audit.auditMessage) {
        this.$message.error(this.$t('newOaWorkflowDetail.fillDescription'))
        return
      }
      if (audit.auditCode !== '1200' && audit.auditCode !== '1400' && !audit.staffId) {
        this.$message.error(this.$t('newOaWorkflowDetail.selectNextHandler'))
        return
      }

      try {
        const response = await auditOaWorkflow(audit)
        if (response.code === 0) {
          this.$message.success(this.$t('newOaWorkflowDetail.submitSuccess'))
          this._goBack()
        } else {
          this.$message.error(response.msg)
        }
      } catch (error) {
        this.$message.error(error)
      }
    },
    async _loadNextAuditPerson() {
      try {
        const params = {
          communityId: this.communityId,
          taskId: this.newOaWorkflowDetailInfo.audit.taskId,
          flowId: this.newOaWorkflowDetailInfo.flowId,
          id: this.newOaWorkflowDetailInfo.id
        }
        const response = await getNextTask(params)
        if (response.code != '0') return
        this.newOaWorkflowDetailInfo.nextAudit = response.data[0]
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _getNewOaWorkflowDetailState(pool) {
      if (!Object.prototype.hasOwnProperty.call(pool, 'state')) {
        return this.$t('newOaWorkflowDetail.unknown')
      }
      this.status = pool.state
      switch (pool.state) {
        case '1001':
          return this.$t('newOaWorkflowDetail.apply')
        case '1002':
          return this.$t('newOaWorkflowDetail.pendingReview')
        case '1003':
          return this.$t('newOaWorkflowDetail.returned')
        case '1004':
          return this.$t('newOaWorkflowDetail.transferred')
        case '1005':
          return this.$t('newOaWorkflowDetail.completed')
        default:
          return this.$t('newOaWorkflowDetail.unknown')
      }
    },
    getDisplayValue(item, value) {
      // 对于 select 类型，根据 value 查找对应的 label
      if (item.type === 'select' && item.values && value !== undefined && value !== null && value !== '') {
        const option = item.values.find(opt => opt.value === value || opt.value === String(value))
        return option ? option.label : value
      }
      // 对于 textdate 类型，去掉时分秒，只显示日期部分
      if (item.type === 'textdate' && value) {
        return value.split(' ')[0]
      }
      return value
    },
    async _openNewOaWorkflowDetailImg() {
      try {
        const params = {
          communityId: this.communityId,
          businessKey: this.newOaWorkflowDetailInfo.id
        }
        const response = await listRunWorkflowImage(params)
        if (response.code !== 0) return
        this.newOaWorkflowDetailInfo.imgData = 'data:image/png;base64,' + response.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.new-oa-workflow-detail-container {
  padding: 20px;

  .mt-20 {
    margin-top: 20px;
  }

  .float-right {
    float: right;
  }

  .text-center {
    text-align: center;
  }

  .el-form-item {
    margin-bottom: 0;
  }

  .kv-item {
    display: flex;
    align-items: center;
    line-height: 32px;
    padding: 4px 0;

    .kv-label {
      color: #606266;
      font-size: 14px;
      white-space: nowrap;
      flex-shrink: 0;
    }

    .kv-value {
      color: #303133;
      font-size: 14px;
      word-break: break-all;
    }
  }
}
</style>